import type { Media_Url_Fragment$data } from '@/graphql/mutations/Media.mutation';
import type { MediaItem, MediaItemSizeEnum } from '@/graphql/types';
import type { FragmentData } from '@/graphql/utils';
import { FastAverageColor } from 'fast-average-color';
import slufigy from 'react-slugify';
/**
 * For a given image - get the average color and return it as a rgba string
 */
export const getImageBackgroundColor = async (image: string | null | undefined): Promise<string | null> => {
  if (!image) return null;
  const fac = new FastAverageColor();

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = image;

  try {
    const color = await fac.getColorAsync(img, { crossOrigin: 'Anonymous' });
    const rgb = color.value;

    // create new rgba with opacity of 0.25
    const rgba = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.25)`;

    return rgba;
  } catch (e) {
    return null;
  }
};

export type ZnMediaItem = FragmentData<Media_Url_Fragment$data> | MediaItem;

export const getMediaItemUrl = (
  mediaItem: ZnMediaItem | null | undefined,
  preferredSize?: MediaItemSizeEnum
): string | null => {
  if (!mediaItem) return null;

  const defaultUrl = mediaItem?.mediaItemUrl ?? null;

  const tokens = mediaItem?.mediaItemUrl ? mediaItem?.mediaItemUrl?.split('.') : null;
  if (!!tokens && tokens?.length > 0) {
    const ext = tokens[tokens.length - 1];
    if (['gif'].includes(ext)) return defaultUrl;
  }

  if (!preferredSize) return defaultUrl;

  const sizes = mediaItem?.mediaDetails?.sizes;
  if (!sizes?.length) return defaultUrl;

  const size = sizes.find((size) => size?.name?.toLowerCase() === preferredSize?.toLowerCase());
  if (!size) return defaultUrl;

  return size.sourceUrl ?? defaultUrl ?? null;
};

/**
 * Format the slug of a post
 */
export const getFormattedSlug = (value: string | null | undefined) => {
  if (!value) return null;
  return slufigy(value, { delimiter: '-' });
};
